import React from "react";
import { Link } from "react-router-dom";

function Header({ cateringMenuUrl, showHero = true }) {
  return (
    <section
      className={`site-home ${showHero ? "site-home-landing" : "site-home-nav-only"}`}
      id="home"
    >
      <nav className="site-nav" aria-label="Main navigation">
        <Link to="/">Home</Link>
        <Link to="/menu">Menu</Link>
        <a href={cateringMenuUrl} target="_blank" rel="noreferrer">
          Catering Menu
        </a>
        <Link to="/after-hours">After Hours</Link>
        <a href="https://doughdays.com.au/" target="_blank" rel="noreferrer">
          Dough Days
        </a>
      </nav>

      {showHero ? (
        <>
          <div className="site-hero-wrap">
            <img
              className="site-hero-image"
              src="/images/DSC0054_Dexter Kim.jpg"
              alt="Cut Lunch schnitz sandwich"
            />
            <img
              className="site-hero-logo"
              src="/images/logos/CUT LUNCH DELI_LOGO_CREAM.png"
              alt="Cut Lunch Deli"
            />
          </div>

          <p className="site-home-copy">
            Cut Lunch Deli is a neighbourhood deli-style sandwich shop in Randwick.
            We focus on seasonal, fresh sandwiches, specialty coffee and sweets baked fresh daily to match.
          </p>
        </>
      ) : null}
    </section>
  );
}

export default Header;
